
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { get } from "../services/cookies";
import Loader from "@/components/common/loaders/Loader";

const RequiredAuth = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = get('token')
 useEffect(() => {
    if (!token) {
        navigate("/login", { state: { from: location?.pathname } });
    } 
  }, [token]);

  if (!token) {
    return <Loader />;
  } 
  return <Outlet />;
};

export default RequiredAuth;